"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var utils_exports = {};
__export(utils_exports, {
  generateMessageId: () => generateMessageId,
  isAppletAttachment: () => isAppletAttachment,
  isAppletAttachmentType: () => isAppletAttachmentType,
  isBlobAttachment: () => isBlobAttachment,
  isBlobAttachmentType: () => isBlobAttachmentType,
  isLinkPreviewAttachment: () => isLinkPreviewAttachment,
  isLinkPreviewAttachmentType: () => isLinkPreviewAttachmentType,
  withTotal: () => withTotal
});
module.exports = __toCommonJS(utils_exports);
var import_communication_types = require("@hcengineering/communication-types");
const COUNTER_BITS = 10n;
const RANDOM_BITS = 10n;
const MAX_SEQUENCE = (1n << COUNTER_BITS) - 1n;
let counter = 0n;
function makeBigIntId() {
  const ts = BigInt(Date.now());
  counter = counter < MAX_SEQUENCE ? counter + 1n : 0n;
  const random = BigInt(Math.floor(Math.random() * Number((1n << RANDOM_BITS) - 1n)));
  return ts << COUNTER_BITS + RANDOM_BITS | counter << RANDOM_BITS | random;
}
__name(makeBigIntId, "makeBigIntId");
function toBase64Url(bytes) {
  let s = "";
  for (const b of bytes) s += String.fromCharCode(b);
  const base64 = typeof btoa === "function" ? btoa(s) : Buffer.from(bytes).toString("base64");
  return base64.replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
}
__name(toBase64Url, "toBase64Url");
function generateMessageId() {
  const idBig = makeBigIntId();
  const buf = new Uint8Array(8);
  new DataView(buf.buffer).setBigUint64(0, idBig, false);
  return toBase64Url(buf);
}
__name(generateMessageId, "generateMessageId");
function isAppletAttachment(attachment) {
  return attachment.type.startsWith("application/vnd.huly.applet.");
}
__name(isAppletAttachment, "isAppletAttachment");
function isLinkPreviewAttachmentType(type) {
  return type === import_communication_types.linkPreviewType;
}
__name(isLinkPreviewAttachmentType, "isLinkPreviewAttachmentType");
function isAppletAttachmentType(type) {
  return type.startsWith("application/vnd.huly.applet.");
}
__name(isAppletAttachmentType, "isAppletAttachmentType");
function isBlobAttachmentType(type) {
  return !isLinkPreviewAttachmentType(type) && !isAppletAttachmentType(type);
}
__name(isBlobAttachmentType, "isBlobAttachmentType");
function isLinkPreviewAttachment(attachment) {
  return attachment.type === import_communication_types.linkPreviewType;
}
__name(isLinkPreviewAttachment, "isLinkPreviewAttachment");
function isBlobAttachment(attachment) {
  return !isLinkPreviewAttachment(attachment) && !isAppletAttachment(attachment) && "blobId" in attachment.params;
}
__name(isBlobAttachment, "isBlobAttachment");
function withTotal(objects, total) {
  const length = total ?? objects.length;
  return Object.assign(objects, { total: length });
}
__name(withTotal, "withTotal");
//# sourceMappingURL=utils.js.map
